import { API } from "@/lib/api";

const SESSION_KEY = "assertimmo_sid";
const ATTR_KEY = "assertimmo_attr";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "gclid", "fbclid"];

const randomId = () =>
  window.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;

const isMobile = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.innerWidth < 768;

// À appeler au tout premier chargement, avant que la navigation n'efface les paramètres d'URL
export const initAttribution = () => {
  if (!sessionStorage.getItem(SESSION_KEY)) sessionStorage.setItem(SESSION_KEY, randomId());
  if (sessionStorage.getItem(ATTR_KEY)) return;
  const q = new URLSearchParams(window.location.search);
  const attr = {};
  PARAMS.forEach((p) => {
    const v = q.get(p);
    if (v) attr[p] = v.slice(0, 200);
  });
  if (!attr.utm_source) attr.utm_source = attr.gclid ? "google" : attr.fbclid ? "facebook" : "direct";
  attr.device = isMobile() ? "mobile" : "desktop";
  sessionStorage.setItem(ATTR_KEY, JSON.stringify(attr));
};

export const getAttribution = () => {
  initAttribution();
  return JSON.parse(sessionStorage.getItem(ATTR_KEY));
};

// Une seule fois par simulateur, étape et session
export const trackStep = (simulateur, etape, extra = {}) => {
  const key = `assertimmo_ev_${simulateur}_${etape}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  fetch(`${API}/track`, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionStorage.getItem(SESSION_KEY), simulateur, etape, ...getAttribution(), ...extra }),
  }).catch(() => {});
};
